import React from "react";
import Button from "react-bootstrap/Button";
import Image from 'react-bootstrap/Image';
import "./SectionHeader.scss";

function SectionHeader(props) {
  // Render nothing if no title or subtitle
  if (!props.title && !props.subtitle) {
    return null;
  }

  var instagramLink = null
  var spotifyLink = null
  var websiteLink = null
  if (props.social) {
    if (props.social.instagram) {
      instagramLink = "https://www.instagram.com/" + props.social.instagram;
      instagramLink = instagramLink.replace('@', '')
    } 
    if (props.social.spotify) {
      spotifyLink = "https://open.spotify.com/user/" + props.social.spotify;
    }
    if (props.social.website) {
      websiteLink = props.social.website
      if (!websiteLink.startsWith("https://") || !websiteLink.startsWith("http://")) {
        websiteLink = "https://" + websiteLink
      }
    }
  }

  return (
    <header
      className={
        "SectionHeader" + (props.className ? ` ${props.className}` : "")
      }
    >
      {
        props.imageUrl && (
          <div style={{height: '150px', width: '150px', margin: '0 auto'}} className="mb-4">
            <Image src={props.imageUrl} roundedCircle fluid />
          </div>
        )
      }

      {props.actionTitle && props.actionOnClick && (
        <div style={{float: 'right'}}>
          <Button variant="primary" onClick={props.actionOnClick}>{props.actionTitle}</Button>
        </div>
      )}
      {props.actionButton && (
        <>{props.actionButton}</>
      )}
      {props.title && (
        <h1
          className={
            "font-weight-bold" +
            (props.subtitle && props.spaced ? " mb-4" : "") +
            (!props.subtitle ? " mb-0" : "") +
            (props.size ? ` h${props.size}` : "")
          }
        >
          {props.title}
        </h1>
      )}

      

      {
        <div className="mt-2">
          {
            instagramLink && (
              <a  href={instagramLink}>
                <i className="fab fa-instagram fa-lg p-2"></i>
              </a>
            )
          }
          {
            spotifyLink && (
              <a href={spotifyLink}>
                <i className="fab fa-spotify fa-lg p-2"></i>
              </a>
            )
          }
          {
            websiteLink && (
              <a href={websiteLink}>
                <i className="fas fa-link fa-lg p-2"></i>
              </a>
            )
          }
        </div>

        }

      {props.subtitle && (
        <p className="SectionHeader__subtitle mb-0">{props.subtitle}</p>
      )}
    </header>
  );
}

export default SectionHeader;
